module.exports = __webpack_public_path__ + "img/关闭代购.e606821b.png";